import styled from "styled-components";
import {InputGroup} from "react-bootstrap";


export const BirthdayPageContainer = styled.section`
  margin: 10px 10px 0 10px;
  
`

export const BirthdayPageArticle = styled.article`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 20px;
  cursor: pointer;
  border: 1px solid black;
  border-radius: 15px;
  max-width: 200px;
  width: 100%;
  align-items: center;
  &:hover {
    background: rgba(246, 238, 229, 0.5);
  }
  

  @media (max-width: 760px) {
    &:hover {
      background: transparent;
    }
    cursor: none;
  }
`
export const BirthdayInputGroup = styled(InputGroup)`
  padding: 10px 0;
  position: sticky;
  top: 75px;
  background: white;

  @media (max-width: 760px) {
   top: 50px
  }
`

